import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    color: `${(theme as any).palette.primary.main}`,
  },
  checked: {
    color: `${(theme as any).palette.primary.main}`,
  },
  refusedRoot: {
    color: `${(theme as any).palette.error.main}`,
  },
  refusedChecked: {
    color: `${(theme as any).palette.error.main}`,
    '&.Mui-checked': {
      color: `${(theme as any).palette.error.main}`,
    },
  },
}));
